import { useEffect } from 'react';

/* Empeche la page de defiler derriere une fenetre modale.

   Sans cela, la molette fait glisser le contenu du dessous : on croit faire
   defiler la fiche, c'est la liste qui bouge, et en refermant on a perdu sa
   place. On bloque donc le defilement du document tant que la fenetre est
   ouverte, en compensant la largeur de la barre de defilement pour que la
   page ne saute pas lateralement au moment du blocage.

   Usage : useBlocageDefilement(Boolean(fenetreOuverte)); */
export function useBlocageDefilement(actif) {
  useEffect(() => {
    if (!actif) return undefined;
    const corps = document.body;
    const overflowAvant = corps.style.overflow;
    const margeAvant = corps.style.paddingRight;
    const largeurBarre = window.innerWidth - document.documentElement.clientWidth;
    corps.style.overflow = 'hidden';
    if (largeurBarre > 0) {
      const margeActuelle = parseFloat(window.getComputedStyle(corps).paddingRight) || 0;
      corps.style.paddingRight = `${margeActuelle + largeurBarre}px`;
    }
    return () => {
      corps.style.overflow = overflowAvant;
      corps.style.paddingRight = margeAvant;
    };
  }, [actif]);
}

export default useBlocageDefilement;
